import { OrmModel, StringField, AttrField } from 'vuex-orm-decorators'

import { modelNames } from '@/data/models/types'
import { ExternalIntegration, ExternalIntegrationProvider } from '@/data/models/domain/externalIntegrations'
import type { ZohoExternalIntegrationSettings } from '@/services/domain/externalIntegrations/types'

@OrmModel(modelNames.ZOHO_EXTERNAL_INTEGRATION, modelNames.EXTERNAL_INTEGRATION)
export class ZohoExternalIntegration extends ExternalIntegration {
  @StringField(ExternalIntegrationProvider.ZOHO)
  public provider: ExternalIntegrationProvider.ZOHO

  @AttrField(null)
  public settings: ZohoExternalIntegrationSettings | null
}

export default ZohoExternalIntegration
